<script>
    import BlogSummary from '../components/BlogSummary.svelte';
    export let short = false;
    export let blogUrl = "aloittamisen_vaikeus";
    let title = "Liikunnan aloittamisen vaikeus";
    let author = "Petteri";
    let blogDate = "4.10.2015";
    let titlePic = "handstand_lidl.jpg";
    let firstPara = "Häpeä estää monia liikkumasta julkisesti tai aloittamasta elämäntapamuutosta. Ethän anna kynnyksen nousta liian korkeaksi.";
</script>

<!-- Yhteenveto (etusivu ja blogitesktisivu) -->
{#if short}
<BlogSummary blogPath={blogUrl} title={title} titlePic={titlePic} blogDate={blogDate} firstPara={firstPara}></BlogSummary>

<!-- Vasinainen artikkeli -->
{:else}
    <div class="blog page">
        <article class="container">
            <h1>{title}</h1>
            <div class="blogDate">{author} | {blogDate}</div>

            <div class="blogMainImage" style="background-image: url('/svelte-site/img/blog/{titlePic}')"></div>
            <!-- <p>{firstPara}</p> -->



            <p>Moni kuntosalillemme soitteleva heittää loppuun vielä kysymykset "uskaltaako sinne tulla" tai 
                "pitäisiköhän sitä vähän ensin treenata että sitten varmasti osaan liikkua oikein". 
                Jäin miettimään näitä kysymyksiä, että mikä meitä pelottaa liikkumisessa. Osaa voi toki pelottaa 
                loukkaantumiset ja niitähän on syytäkin pelätä tiettyyn rajaan saakka, mutta luulenpa että suurin 
                pelon syy on häpeä. </p>
                  
                <p>Häpeä omaa fyysistä kuntoa, olemusta tai kankeutta kohtaan. Enitenhän suomalaiset tuntuvat 
                miettivän että "mitähän nuo muut minusta ajattelevat". Vaikka lopulta kaikki keskittyvät niin 
                omaan itseen ettei riitä aikaa huomata mitä muut tekevät, saati arvostella sitä.</p>

                <p>Otetaan esimerkiksi kuntosalihäpeä. Ensimmäisiä kertoja kuntosalille menevä saattaa kuvitella, 
                että kaikki katsovat hän treenaa ja - hui kauhiustus - jos epäonnistun niin kaikki nauravat tai 
                vähintäänkin mielessän ilkkuvat. Todellisuudessa sinne salille hyvin solahtaa sekaan eikä kukaan 
                kiinnitä sen enempää huomioita. Ehkä tervehtii ja hyvällä tuurilla vieläpä kysyy kuulumiset.</p>
               
                <p>Asioita oppii vain tekemällä. Voimme ottaa esimerkiksi uuden puhutun kielen oppimisen, joka 
                onnistuu lapsilta käsittämättömän hyvin. Yksi hyvin merkittävä tekijä tässä on se että lapset 
                yrittävät puhua rohkeasti. Virheitä tulee, mutta sillä ei ole väliä. Yritys on kova. Aikuisten 
                kielen opettelu tyssää usein siihen, että ei uskalleta puhua, koska voi tulla VIRHE. Sepäs vasta 
                on häpeällistä. Voimme tuoda tämän oppimiskäytännön liikkumiseen. Kukaan ei syntyään osaa tehdä 
                leukaa, punnertaa maasta puhtaasti tai heittää ensimmäisillä kävelyaskelilla volttia. Lihakset, 
                liikeradat, taidot ja oman kehon tunnistaminen kehittyvät vasta, kun niitä harjoittaa.</p>
            
                <p>Liikkumisen pitäisi olla meille luonnollista. Ei tarvitse tehdä kummoisia temppuja, kun alkaa 
                jo keräämään ihmetteleviä katseita. Olimme eräänä viikonloppuna tulossa pitkältä automatkalta 
                Etelä-Suomesta. Huoltoasematauolla puoliso yllytti tekemään 10 kyykkyä, jotta veri lähtisi hitusen 
                kiertämään kankeissa Audin jäykistämissä jäsenissä. Ulko-oven vieressä oli miesporukkaa tupakalla, 
                joten ensimmäinen ajatus joka minulla(kin!!) tuli mieleen, että kehtaako tehdä kymmentä kyykkyä. 
                Puolen sekunnin päästä tein kyykyt ja matka jatkui ensitä pirteämpänä. Kannatti siis.</p>
               
                <h3>Pitäisikö liikkumisen häpeästä päästä eroon?</h3>

                <p>Meillä kaikilla on omat elämäntilanteemme. Toisilla elämäntilanne on voinut sallia liikkumisen 
                ihan eri ajankäytöllä kuin toislla. Tämä antaa jo hyvän etumatkan muille. Minä "löysin" 
                liikunnan vasta reilu 20 vuoden iässä. Näin siis junnuna aloittaneilla kavereillani on jopa 
                kymmenen vuoden etumatka minuun nähden. Huippu-urheilijoiksi aikovat ovat aloittaneet uransa 
                jo nuorena. Vanhempana liikkumisen aloittamisessa valoisana puolena on se, että potentiaalia 
                kehittymiseen ja omien ennätyksien rikkomiseen on elämän ehtoopuolelle asti. Huippu-urheilijoilla 
                ennätykset sijoittuvat nuoruusvuosiin ja siitä alkaakin nöyrä alamäki. Koskaan ei siis ole liian 
                myöhäistä!</p>

                <p>Kukaan ei voi tietää, millaista liikkuminen 
                juuri sinusta tuntuu. Voihan olla, että olet juuri toipumassa olkapäävammasta tai läpikäynyt 
                elämässäsi jonkin suuren haasteen josta olet toipumassa. Se mitä toiset sinusta ajattelevat on 
                yhdentekevää. Merkityksellistä on vain se pidätkö itsesi liikkeessä vaiko et ja nautitko siitä.</p>
                
                <p>Uuden liikuntamuodon aloittamisessa tarvitaan rohkeutta uskaltaa kokeilla 
                asioita. Liikkumisen pitäisi olla ihmiselle se luonnollinen juttu. Sillä voidellaan nivelet, 
                laitetaan kuona-aineet liikkeelle, parannetaan mielenlaatua, turvataan omaa tulevaisuutta... lista on loputon.
                </p>

                <p>Muista, liike lähtee sinusta!</p>
                
                <p>-Petteri</p>


        </article>



        <section class="container">
            <h2>Lue seuraavaksi</h2>
            <div class="row">
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='stressaako' title='Stressaako?' titlePic='stressi.jpg' blogDate='' firstPara='Viime aikoina on puhuttu paljon stressistä ja sen vaikutuksista. Pitkittyneellä stressireaktiolla on yhteys elimistön lievään tulehdustilaan, joka voi johtaa monenlaisiin ongelmiin.'></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='vastuskuminauhat_6_vinkkia' title='6 vinkkiä vastuskuminauhojen hyödyntämiseen' titlePic='2014/etunojapunnerrus2.jpg' blogDate='' firstPara='Vastuskuminauhat ovat hauska ja tehokas tapa tuoda monipuolisuutta ja vaihtelua harjoitteluun. Lue tästä vinkit vaskuskuminauhojen hyödyntämiseen treeneissä.'></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='miten-tehda-treenaamisesta-hauskaa' title='Miten tehdä treenaamisesta hauskaa?' titlePic='dynamopaidat.jpg' blogDate='' firstPara='Salilla on kiva käydä ja siitä tulee keskimäärin mukavampaa, jos siellä kehittyy. Eikö vain?'></BlogSummary>
                </article>
            </div>
        </section>

    </div>
{/if}

<style>


</style>
